export default __webpack_public_path__ + "static/media/SuperLikes.d31e7f13.jpeg";